import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { Feature } from '@treasury/domain/services/feature-flags';
import { LocalStorageService } from '@treasury/utils';
import { css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { windowMaximizeIcon, windowMinimizeIcon } from '../assets/icons';
import { TmContainer } from '../tm-container.component';

const PAYMENT_HUB_SIDEBAR_KEY = 'payment-sidebar';

export const tagName = 'tm-sidebar';
@customElement(tagName)
export class TmSidebar extends TmContainer {
    @InjectProperty()
    declare private localStorage: LocalStorageService;

    @state()
    private sidebarOpen: boolean = false;

    @state()
    private paymentHubEnabled = false;

    protected async firstUpdated() {
        this.sidebarOpen = this.localStorage.get(PAYMENT_HUB_SIDEBAR_KEY) ?? false;
        this.paymentHubEnabled = await (
            await this.featureFlagService
        ).isEnabled(Feature.PwaPaymentHub);
    }

    protected render() {
        return html`<div class="flex h-full">
            <slot name="main-content"></slot>
            ${this.isDesktop && this.paymentHubEnabled
                ? html`<div
                      class=${classMap({
                          'flex-shrink-0 flex flex-col items-end pt-1 pr-2 overflow-clip transition-all duration-500': true,
                          'w-[358px]': this.sidebarOpen,
                          'w-[32px]': !this.sidebarOpen,
                      })}
                  >
                      <button
                          @click=${() => {
                              this.sidebarOpen = !this.sidebarOpen;
                              this.localStorage.set(PAYMENT_HUB_SIDEBAR_KEY, this.sidebarOpen);
                          }}
                      >
                          <tm-icon
                              .icon=${this.sidebarOpen ? windowMinimizeIcon : windowMaximizeIcon}
                              color="var(--content-default)"
                          ></tm-icon>
                      </button>

                      <div
                          class=${classMap({
                              'transition-all duration-500': true,
                              'opacity-100': this.sidebarOpen,
                              'opacity-0': !this.sidebarOpen,
                              'translate-x-full': !this.sidebarOpen,
                          })}
                      >
                          <div class="min-w-[350px]">
                              <slot name="sidebar-content" slot="sidebar-content"></slot>
                          </div>
                      </div>
                  </div>`
                : nothing}
        </div>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                }
            `,
        ];
    }
}
declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmSidebar;
    }
}
